class VideoParallax {
  constructor() {
    this.initParallax();
  }

  initParallax() {
    const videoWrappers = document.querySelectorAll('[data-section-type="video-section"]');

    if (!videoWrappers) {
      return;
    }

    videoWrappers.forEach((videoWrapper) => {
      document.addEventListener('scroll', () => {
        const scrollPositionY = window.scrollY;

        videoWrapper.querySelector('.hero__text-shadow').style.transform = `translate3d(0, ${scrollPositionY * 0.3}px, 0)`;
      });
    });
  }
}

export default VideoParallax;
